export const parseFeatureFlagsOverrides = (envValue: string) => {
  const result: Record<string, string> = {};

  envValue
    .replace(/\s/g, "")
    .split(";")
    .filter(Boolean)
    .forEach((flag) => {
      const [name, value] = flag.split("=");
      result[name] = value;
    });

  return result;
};
